module.exports = __webpack_public_path__ + "static/teenage_depression_graph-5a3be6af6b22555ab3dbf1c3e0c5555b.png";